import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../config/hooks";
import { createContactApi, updateContactApi } from "../../slices/salesSlice";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import useFormDraft from "../../utils/custome-hooks/useFormDraft";

interface ContactDetail {
  firstName: string;
  lastName: string;
  email: string;
  alternateEmail:string;
  alternateCountryCode:number;
  alternatePhoneNumber:number;
  countryCode: number;
  phoneNumber: number;
  designation: string;
  location: string;
  isPrimary: boolean;
}

const ContactDetailForm = ({
  togglePopupHandler,
  isUpdate = false,
  initialData,
}) => {
  const dispatch = useAppDispatch();
  const {countries}=useAppSelector((state)=>state.appConfig);
  const clientId = useParams();
  // const [contactDetail, setContactDetail] = useState<ContactDetail>({
  //   firstName: "",
  //   lastName: "",
  //   email: "",
  //   alternateEmail: "",
  //   countryCode: 91,
  //   phoneNumber: "",
  //   alternateCountryCode: 91,
  //   alternatePhoneNumber:"",
  //   designation: "",
  //   location: "",
  //   isPrimary: false,
  // });

  const [contactDetail, setContactDetail, clearDraft] = useFormDraft<ContactDetail>(
    `contact-form ${clientId.clientId}`,
    initialData || {
      firstName: "",
      lastName: "",
      email: "",
      alternateEmail: "",
      countryCode: 91,
      phoneNumber: "",
      alternateCountryCode: 91,
      alternatePhoneNumber: "",
      designation: "",
      location: "",
      isPrimary: false,
    },
    isUpdate // disable saving when in update mode
  );
  // const [isUpdate, setIsUpdate] = useState(false); // Determine if it's an update or create
  useEffect(() => {
    if (isUpdate && initialData) {
      // If in update mode, set the contact data to initial data
      setContactDetail(initialData);
    }
  }, [isUpdate, initialData]);

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value, type, checked } = e.target;
    setContactDetail({
      ...contactDetail,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    // contactDetail.phoneNumber=Number(contactDetail.phoneNumber)
    
    const contactData = {
      ...contactDetail,
      phoneNumber: Number(contactDetail.phoneNumber), // Convert phoneNumber to a number here
      countryCode: Number(contactDetail.countryCode), 
      alternatePhoneNumber: Number(contactDetail.alternatePhoneNumber), // Convert phoneNumber to a number here
      alternateCountryCode: Number(contactDetail.alternateCountryCode),
    };
    
    // const apiEndpoint = isUpdate ? "/api/updateContact" : "/api/createContact";
    // const method = isUpdate ? "PUT" : "POST";

    try {
      if (isUpdate) {
        // Dispatch update action if in update mode
        dispatch(updateContactApi({ ...contactData }));
        toast.success("Contact Updated Successfully");
        togglePopupHandler(false);
      } else {
        dispatch(
          createContactApi({ clientId: clientId.clientId, ...contactData })
        );
        toast.success("Contact Created Successfully");
        clearDraft()
        togglePopupHandler(false);
      }
    } catch (error) {
      alert("There was an error submitting the form.");
    }
  };

  return (
    <form
  onSubmit={handleSubmit}
  className="w-full max-w-3xl mx-auto pr-2 max-h-[80vh] bg-white rounded-xl space-y-2 overflow-y-auto"
>
  <h2 className="text-xl font-semibold text-gray-800 mb-4  pb-2">Contact Details</h2>

  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div>
      <label className="block text-gray-600 mb-1">First Name *</label>
      <input
        type="text"
        name="firstName"
        value={contactDetail.firstName}
        onChange={handleChange}
        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring focus:ring-primary-200"
        required
      />
    </div>

    <div>
      <label className="block text-gray-600 mb-1">Last Name *</label>
      <input
        type="text"
        name="lastName"
        value={contactDetail.lastName}
        onChange={handleChange}
        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring focus:ring-primary-200"
        required
      />
    </div>
  </div>

  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div>
      <label className="block text-gray-600 mb-1">Email</label>
      <input
        type="email"
        name="email"
        value={contactDetail.email}
        onChange={handleChange}
        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring focus:ring-primary-200"
      />
    </div>

    <div>
      <label className="block text-gray-600 mb-1">Alternate Email</label>
      <input
        type="email"
        name="alternateEmail"
        value={contactDetail.alternateEmail}
        onChange={handleChange}
        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring focus:ring-primary-200"
      />
    </div>

    <div>
      <label className="block text-gray-600 mb-1">Designation</label>
      <input
        type="text"
        name="designation"
        value={contactDetail.designation}
        onChange={handleChange}
        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring focus:ring-primary-200"
      />
    </div>

    <div>
      <label className="block text-gray-600 mb-1">Location</label>
      <input
        type="text"
        name="location"
        value={contactDetail.location}
        onChange={handleChange}
        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring focus:ring-primary-200"
      />
    </div>
  </div>

  <h3 className="text-lg font-semibold text-gray-700 pt-4">Phone Numbers</h3>

  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div className="flex gap-2">
      {/* <input
        type="number"
        name="countryCode"
        value={contactDetail.countryCode}
        onChange={handleChange}
        onWheel={(e) => e.currentTarget.blur()}
        className="w-1/3 px-3 py-2 border rounded-md"
        required
      /> */}

      <select
        name="countryCode"
        value={contactDetail.countryCode}
        onChange={handleChange}
        className="border border-gray-300 rounded-md p-2 w-1/3"
      >
        {/* <option value="">Country code</option> */}
        {countries.map((code, index) => (
          <option key={index} value={Math.floor(code.PhoneCode)}>
            {code.Iso2} +{code.PhoneCode}
          </option>
        ))}
      </select>
      <input
        type="text"
        name="phoneNumber"
        placeholder="Phone"
        value={contactDetail.phoneNumber}
        minLength={6}
        maxLength={15}
        onChange={(e) => {
          const value = e.target.value;
          if (/^\d*$/.test(value) && value.length <= 15) {
            handleChange(e);
          }
        }}
        className="w-2/3 px-3 py-2 border rounded-md"
      />
       {contactDetail?.phoneNumber.toString()?.length > 0 &&
      contactDetail?.phoneNumber.toString()?.length < 6 && (
        <p className="text-red-500 text-sm">Phone number must have 6 digits.</p>
      )}
    </div>
   

    <div className="flex gap-2">
      {/* <input
        type="number"
        name="alternateCountryCode"
        value={contactDetail.alternateCountryCode}
        onChange={handleChange}
        onWheel={(e) => e.currentTarget.blur()}
        className="w-1/3 px-3 py-2 border rounded-md"
        required
      /> */}
      
      <select
        name="alternateCountryCode"
        value={contactDetail.alternateCountryCode}
        onChange={handleChange}
        className="border border-gray-300 rounded-md p-2 w-1/3"
      >
        {/* <option value="">Country code</option> */}
        {countries.map((code, index) => (
          <option key={index} value={Math.floor(code.PhoneCode)}>
            {code.Iso2} +{code.PhoneCode}
          </option>
        ))}
      </select>
      <input
        type="text"
        name="alternatePhoneNumber"
        placeholder="Alternate Phone "
        value={contactDetail.alternatePhoneNumber}
        minLength={6}
        maxLength={15}
        onChange={(e) => {
          const value = e.target.value;
          if (/^\d*$/.test(value) && value.length <= 15) {
            handleChange(e);
          }
        }}
        className="w-2/3 px-3 py-2 border rounded-md"
      />
      {contactDetail?.alternatePhoneNumber?.toString().length > 0 &&
       contactDetail?.alternatePhoneNumber?.toString().length < 6 && (
        <p className="text-red-500 text-sm">Phone number must have 6 digits.</p>
      )}
    </div>
    

  </div>

  <div className="pt-1">
    <label className="inline-flex items-center text-gray-700">
      <input
        type="checkbox"
        name="isPrimary"
        checked={contactDetail.isPrimary}
        onChange={handleChange}
        className="mr-2"
      />
      Mark as Primary Contact
    </label>
  </div>

  <div className="flex justify-end">
    <button
      type="submit"
      className="bg-primary-600 hover:bg-primary-500 text-white font-medium py-2 px-6 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-300"
    >
      {isUpdate ? "Update" : "Create"}
    </button>
  </div>
</form>

  );
};

export default ContactDetailForm;
